import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Image, Dropdown, Grid } from 'semantic-ui-react';

import cm from 'helpers/commons';
import storage from 'helpers/storage';
import logo from 'images/logo.png';

import * as bookMark from 'actions/bookMark';

import SurveyModal from './SurveyModal';

const propTypes = {};

const defaultProps = {};

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grade: null,
      companyList: null
    };
  }

  componentWillMount() {
    const company = storage.get('company');
    let companyList = null;

    if (company.user.grade === 'SUPER') {
      companyList = cm.selectDataForMat(company.list, null, 'company');
    }
    this.setState({
      grade: company.user.grade,
      companyList: companyList
    });
  }

  /*
    Selectbox
    회사 변경
  */
  handleChange = async (e, data) => {
    const { authAction, bookMark } = this.props;

    if (e.keyCode !== 38 && e.keyCode !== 40) {
      //company me 호출
      try {
        const { company } = this.props;
        const userID = (storage.get('company') || {}).userID;

        storage.set('company', {
          userID: userID,
          user: company.data.user,
          id: data.value,
          info: company.data.user.company,
          list: company.data.company
        });
        location.href = '/main/dashBoard';
      } catch (e) {
        console.log('###### handleChange error : ', e);
      } finally {
      }
    }
  };

  goMain = () => {
    this.context.router.history.push('/main/dashBoard');
  };

  goMyInfo = () => {
    this.context.router.history.push('/main/MyInfo');
  };

  render() {
    const { grade, companyList } = this.state;
    const { logout } = this.props;
    let comId = 0;
    let userName = (storage.get('company') || {}).userID;

    if (grade === 'SUPER') {
      comId = (storage.get('company') || {}).id;
    }
    return (
      <div className="logo inner">
        <div className="lnb-title">
          <Image src={logo} centered height={48} onClick={this.goMain} />
        </div>
        <div className="company-sel">
          {grade === 'SUPER' ? (
            <Dropdown
              fluid
              search
              selection
              placeholder="회사"
              value={comId}
              options={companyList}
              onChange={this.handleChange}
            />
          ) : null}
        </div>
        <div className="loginout">
          <Grid>
            <Grid.Column>
              <span style={{ padding: '10px', textDecoration: 'underline' }} onClick={this.goMyInfo}>
                {userName}
              </span>
              <span>|</span>
              <span className="loginout-btn" onClick={logout}>
                로그아웃
              </span>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

List.propTypes = propTypes;
List.defaultProps = defaultProps;

List.contextTypes = {
  router: PropTypes.object.isRequired
};

List = connect(
  (state) => ({
    company: state.auth.company
  }),
  (dispatch) => ({
    bookMark: bindActionCreators(
      {
        list: bookMark.List
      },
      dispatch
    )
  })
)(List);

export default List;
